import React, { useContext } from 'react';
import { Checkbox, Descriptions, Form, Input, Radio } from 'antd';
import { useTranslation } from 'react-i18next';
import { TextAreaQuill } from '../../../atoms/textarea/TextAreaQuill';
import { MAX_LENGTH_DESCRIPTION } from '../../../../constants/common';
import { TOUR_TRASH_TRANSLATION } from '../../../../constants/define/translation';
import { CountryContext } from '../../../../repository/context/countryContext';

interface TourTrashNameSectionProps {
  length: number;
  isReachedMax: boolean;
  onHandleKeyChange: () => void;
  onChangeCheckbox: (checkedValues: any) => void;
  onCheckAllChange: (e: any) => void;
  onSetTitle: any;
  onHandleChange: (content: any, delta: any, source: any, editor: any) => void;
  isHandleViewTourTrash: boolean;
  beginCheck: boolean;
  listTier: any;
}

const plainOptions = [
  { label: 'On The Tee', value: 'On The Tee' },
  { label: 'Par', value: 'Par' },
  { label: 'Birdie', value: 'Birdie' },
  { label: 'Eagle', value: 'Eagle' },
];

export const TourTrashNameSection = (props: TourTrashNameSectionProps) => {
  const { t } = useTranslation(TOUR_TRASH_TRANSLATION);
  const {
    length,
    isReachedMax,
    onHandleKeyChange,
    onHandleChange,
    isHandleViewTourTrash,
    beginCheck,
    onSetTitle,
    listTier,
    onCheckAllChange,
    onChangeCheckbox,
  } = props;
  const countryContext = useContext(CountryContext);
  const checkAll = plainOptions.length === listTier.length;

  const countryOptions: any[] = countryContext?.countryList?.map(item => {
    return {
      value: item?.code,
      label: item?.name,
    };
  });

  return (
    <>
      <Descriptions title={t('tab.detail.form.name.countries')} />
      <Form.Item name="countries" rules={[{ required: true, message: t('tab.detail.form.validate.countryBlank') }]}>
        <Radio.Group options={countryOptions} />
      </Form.Item>
      <Descriptions title={t('tab.detail.form.name.loyaltyTier')} />
      <Form.Item
        name="loyaltyTier"
        rules={[{ required: true, message: t('tab.detail.form.validate.loyaltyTierBlank') }]}
      >
        <Checkbox onChange={onCheckAllChange} checked={checkAll}>
          All
        </Checkbox>
        <Checkbox.Group
          value={listTier}
          options={plainOptions}
          onChange={onChangeCheckbox}
          disabled={listTier.length === 4}
        />
      </Form.Item>
      <Descriptions title={t('tab.detail.form.name.title')} />
      <Form.Item name="title" rules={[{ required: true, message: t('tab.detail.form.validate.titleBlank') }]}>
        <Input
          placeholder={t('tab.detail.form.name.titlePlaceholder')}
          readOnly={isHandleViewTourTrash}
          disabled={isHandleViewTourTrash}
          onChange={onSetTitle}
        />
      </Form.Item>
      <Descriptions title={t('tab.detail.form.name.descriptionPlaceholder')} />
      <Form.Item
        className="form-description"
        name="description"
        initialValue=""
        validateStatus={isReachedMax || length === 0 ? 'error' : 'success'}
        help={beginCheck && `${length} characters (${MAX_LENGTH_DESCRIPTION} maximum)`}
      >
        <TextAreaQuill
          theme="snow"
          bounds=".quill"
          placeholder={t('tab.detail.form.name.descriptionPlaceholder')}
          onKeyDown={onHandleKeyChange}
          onKeyUp={onHandleKeyChange}
          onChange={onHandleChange}
          readOnly={isHandleViewTourTrash}
        />
      </Form.Item>
    </>
  );
};
